export default "__VITE_ASSET__BH71susa__"